export const SELECT_THEME = 'SELECT_THEME';
export const SELECT_LANGUAGE = 'SELECT_LANGUAGE';
export const UOM_WIDTH_LANGUAGE = 'UOM_WIDTH_LANGUAGE'